import React, { useEffect, useState } from 'react';
import './App.css';
import "../src/cmp/QuizModule/quiz.css"
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './cmp/header';
import Footer from './cmp/footer';
import Home from './cmp/home';
import Login from './cmp/login';
import Signup from './cmp/signup';
import ForgotPassword from './cmp/forgot_password';
import ContactUs from './cmp/contact-us';
import Terms from './cmp/terms';
import Privacy from './cmp/privacy';
import ContactForm from './cmp/contact-form';
import AboutUs from './cmp/about-us';
import Cases from './cmp/cases';
import CaseDetail from './cmp/case-detail';
import Chapters from './cmp/chapters';
import ViewChapter from './cmp/view-chapter';
import QuizList from './cmp/quiz-list';
import QuizView from './cmp/QuizView';
import ViewDrugRefs from './cmp/view-drug-refs';
import MedicalTerms from './cmp/medical-terms';
import SubscriptionPage from './cmp/subscription_page';
import Protocols from './cmp/protocols';
import ProtocolDetail from './cmp/protocol-detail';
import './cmp/protocols.css';

import FractureQuizList from './cmp/fracture-quiz/FractureQuizList';
import FractureQuizCase from './cmp/fracture-quiz/FractureQuizCase';
import Illustrations from './cmp/illustrations/Illustrations';
import ViewIllustration from './cmp/illustrations/ViewIllustration';

import AdminApp from './cmp/admin/App';

import RootStore from './cmp/redux/RootStore';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import db from "./cmp/firebase/firebase";
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
};

const HomeContainer = () => {
  const location = useLocation();

  const isViewChapter = location.pathname === '/view-chapter';

  useEffect(() => {
    if (isViewChapter) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isViewChapter]);

  const [contactInfo, setContactInfo] = useState({});
  useEffect(() => {
    loadInfo()
  }, [])

  const loadInfo = async () => {
    let doc = await db.collection('contact-info')
      .doc('contact-info')
      .get()
    let data = doc.data()
    setContactInfo(data)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <div style={{ width: '100%' }}>
        <ScrollToTop />
        <Header contactInfo={contactInfo} />
        <div style={{ marginTop: 0 }}>
          <Routes>
            <Route path="/" element={<Home contactInfo={contactInfo} />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/reset-password" element={<ForgotPassword />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact-form" element={<ContactForm />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/case-detail" element={<CaseDetail />} />
            <Route path="/chapters" element={<Chapters />} />
            <Route path="/view-chapter" element={<ViewChapter />} />
            <Route path="/quiz-list" element={<QuizList />} />
            <Route path="/quiz" element={<QuizView />} />
            <Route path="/fracture-quiz" element={<FractureQuizList />} />
            <Route path="/fracture-quiz/case/:id" element={<FractureQuizCase />} />
            <Route path="/illustrations" element={<Illustrations />} />
            <Route path="/view-illustration" element={<ViewIllustration />} />
            <Route path="/view-drug-refs" element={<ViewDrugRefs />} />
            <Route path="/medical-terms" element={<MedicalTerms />} />
            <Route path="/subscribe" element={<SubscriptionPage />} />
            <Route path="/protocols" element={<Protocols />} />
            <Route path="/protocols/:protocolId" element={<ProtocolDetail />} />
          </Routes>
        </div>
        {!isViewChapter && <Footer contactInfo={contactInfo} />}
      </div>
    </div>
  );
};

class App extends React.Component {
  componentDidMount = () => {
    console.log('MOUNT');
  };

  render() {
    return (
      <Provider store={RootStore}>
        <Router>
          <Routes>
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="/*" element={<HomeContainer />} />
          </Routes>
          <ToastContainer />
        </Router>
      </Provider>
    );
  }
}

export default App;
